export default "__VITE_ASSET__CL14erA4__"